import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  private elRef = inject<ElementRef<HTMLElement>>(ElementRef);

  ngAfterViewInit(): void {
    const input = this.elRef.nativeElement.querySelector<HTMLInputElement | HTMLTextAreaElement>('input, textarea');

    if (input) {
      // prevent ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        if (input instanceof HTMLTextAreaElement) {
          input.setSelectionRange(0, 0);
          input.focus({ preventScroll: true });
          input.scrollTop = 0;

          return;
        }

        input.focus();
      });
    }
  }
}
